import JxtCounterPicto from '../components/JxtCounterPicto';
import JxtClassicPicto from '../components/JxtClassicPicto';
import JxtBookablePicto from '../components/JxtBookablePicto';
import JxtUnbookablePicto from '../components/JxtUnbookablePicto';
import { ResourceStateDtoStatusEnum } from '@jooxter/api';
import { getOccupationStatus } from '@jooxter/utils';

const useRenderPicto = ({
  capacity,
  occupantsCount,
  size,
  x,
  y,
  status,
  url,
}: {
  capacity?: number;
  occupantsCount?: number;
  size: number;
  x: number;
  y: number;
  status?: ResourceStateDtoStatusEnum;
  url: string;
}) => {
  const occupationStatus = getOccupationStatus(url);
  const pictoSvg = () => {
    if (url.startsWith('images/counter')) {
      return (
        <JxtCounterPicto
          radius={size / 2.5}
          occupantsCount={occupantsCount}
          capacity={capacity}
          x={x}
          y={y}
          size={size}
          status={status}
        />
      );
    }

    if (url.startsWith('images/bookable')) {
      return (
        <JxtBookablePicto
          radius={size / 2.3}
          occupationStatus={occupationStatus}
          x={x}
          y={y}
          size={size}
          status={status}
        />
      );
    }

    if (url.startsWith('images/unbookable')) {
      return (
        <JxtUnbookablePicto
          radius={size / 2.3}
          occupationStatus={occupationStatus}
          x={x}
          y={y}
          size={size}
          status={status}
        />
      );
    }

    if (url.startsWith('images/classic')) {
      return (
        <JxtClassicPicto
          radius={size / 2.3}
          occupationStatus={occupationStatus}
          x={x}
          y={y}
          size={size}
          status={status}
        />
      );
    }
  };

  return { pictoSvg };
};

export default useRenderPicto;
